import React from 'react'

export const Check = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8 15.9921C12.3765 15.9921 16 12.3626 16 7.99605C16 3.62175 12.3687 0 7.99217 0C3.62353 0 0 3.62175 0 7.99605C0 12.3626 3.63138 15.9921 8 15.9921ZM7.12157 11.8295C6.85492 11.8295 6.63531 11.7197 6.43139 11.4454L4.46276 9.03086C4.34511 8.87405 4.27452 8.7016 4.27452 8.52132C4.27452 8.16851 4.54903 7.87845 4.90197 7.87845C5.12942 7.87845 5.30198 7.94903 5.49805 8.20771L7.09024 10.2616L10.4393 4.88387C10.5882 4.6487 10.7922 4.52327 10.9961 4.52327C11.3412 4.52327 11.6628 4.75844 11.6628 5.12689C11.6628 5.29936 11.5608 5.47966 11.4667 5.64428L7.78041 11.4454C7.6157 11.7041 7.38828 11.8295 7.12157 11.8295Z'
        fill='#3A52EE'
      />
    </svg>
  )
}
